((Drupal) => {
  Drupal.behaviors.mediaImageHalfHeightSimple = {
    attach(context) {
      const config = {
        '.paragraph--type--locations .view-content': {
          imageSelector: '.views-row:first-child .media--image img',
          mediaSelector: '.views-row:first-child .media--image',
          targetSelector: '.layout',
        },
        '.paragraph--type--locations-promoted .view-content': {
          imageSelector: '.views-row:nth-child(2) .media--image img',
          mediaSelector: '.views-row:nth-child(2) .media--image',
          targetSelector: '.layout',
        },
        '.paragraph--type--cards': {
          imageSelector: '.subcomponents--grid article .media--image img',
          mediaSelector: '.subcomponents--grid article .media--image',
          targetSelector: '.layout',
          useImmediateParent: true, // Flag to use immediate parent .layout
        },
      };

      const containers = [];

      // Collect all matching containers
      Object.keys(config).forEach((selector) => {
        const elements = context.querySelectorAll(selector);
        elements.forEach((element) => {
          containers.push({ element, config: config[selector] });
        });
      });

      if (containers.length === 0) return;

      const setMediaHalfHeight = () => {
        containers.forEach(({ element, config }) => {
          const mediaElement = element.querySelector(config.mediaSelector);
          if (!mediaElement) return;

          const height = mediaElement.offsetHeight;
          if (height <= 0) return;

          const halfHeight = Math.round(height / 2);

          let target;

          // For cards paragraph type, find the .layout div that contains the subcomponents--grid
          if (
            config.useImmediateParent &&
            config.targetSelector === '.layout'
          ) {
            // Start from the subcomponents--grid element and find its .layout ancestor
            const subcomponentsGrid = element.querySelector(
              '.subcomponents--grid',
            );
            if (subcomponentsGrid) {
              target = subcomponentsGrid.closest('.layout');
            }

            // Fallback: if no subcomponents--grid found, use element's closest .layout
            if (!target) {
              target = element.closest('.layout');
            }
          } else {
            target =
              element.querySelector(config.targetSelector) ||
              element.closest(config.targetSelector);
          }

          if (target) {
            // Store previous value to avoid unnecessary updates
            const currentValue = target.style.getPropertyValue('--media-half-height');
            const newValue = `${halfHeight}px`;

            if (currentValue !== newValue) {
              target.style.setProperty('--media-half-height', newValue);
            }

            // Set layout padding only for .layout targets
            if (config.targetSelector === '.layout') {
              const computedStyle = window.getComputedStyle(target);
              const { paddingTop } = computedStyle;

              target.style.setProperty(
                '--layout-padding-top',
                paddingTop && paddingTop !== '0px' ? paddingTop : '0px',
              );
            }
          }
        });
      };

      const initializeWithImageLoad = () => {
        containers.forEach(({ element, config }) => {
          const image = element.querySelector(config.imageSelector);

          const calculate = () => {
            setTimeout(setMediaHalfHeight, 50);
          };

          if (!image) {
            calculate();
            return;
          }

          if (image.complete && image.naturalHeight > 0) {
            calculate();
          } else {
            image.addEventListener('load', calculate, { once: true });
            image.addEventListener('error', calculate, { once: true });
          }
        });
      };

      // Initialize
      initializeWithImageLoad();

      // Handle resize with increased debounce for smoother transitions
      const resizeHandler = Drupal.debounce(setMediaHalfHeight, 150);

      if ('ResizeObserver' in window) {
        const resizeObserver = new ResizeObserver(resizeHandler);

        containers.forEach(({ element, config }) => {
          const mediaElement = element.querySelector(config.mediaSelector);
          if (mediaElement) {
            resizeObserver.observe(mediaElement);
          }
        });

        // Store for cleanup
        context._mediaResizeObserver = resizeObserver;
      } else {
        window.addEventListener('resize', resizeHandler);
        context._mediaResizeHandler = resizeHandler;
      }
    },

    detach(context, settings, trigger) {
      if (trigger === 'unload') {
        if (context._mediaResizeObserver) {
          context._mediaResizeObserver.disconnect();
          delete context._mediaResizeObserver;
        }

        if (context._mediaResizeHandler) {
          window.removeEventListener('resize', context._mediaResizeHandler);
          delete context._mediaResizeHandler;
        }
      }
    },
  };
})(Drupal);
